export const SET_MODE = 'SET_MODE'

export const MOUSE_ACTION = 'MOUSE_ACTION'
export const TOUCH_ACTION = 'TOUCH_ACTION'

// toggles (queue, activity, discuss)
export const SHOW_TOGGLE = 'SHOW_TOGGLE'
export const HIDE_TOGGLE = 'HIDE_TOGGLE'
export const SWITCH_TOGGLE = 'SWITCH_TOGGLE'

// alerts & notifications
export const SHOW_ALERT = 'SHOW_ALERT'
export const DISMISS_ALERT = 'DISMISS_ALERT'
export const DISMISS_NOTIFICATION = 'DISMISS_NOTIFICATION'
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION'

// sidebar
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'
export const HIDE_SIDEBAR = 'HIDE_SIDEBAR'
export const SET_SIDEBAR_SECTION = 'SET_SIDEBAR_SECTION'
export const RESET_SIDEBAR_SECTION = 'RESET_SIDEBAR_SECTION'
export const SET_SIDEBAR_FILTER = 'SET_SIDEBAR_FILTER'
export const RESET_SIDEBAR_FILTER = 'RESET_SIDEBAR_FILTER'
export const SET_SIDEBAR_DRAG = 'SET_SIDEBAR_DRAG'
export const SET_EDITING_ITEM = 'SET_EDITING_ITEM'

// Share
export const STORE_SHARE = 'STORE_SHARE'

// Queue
export const QUEUE_BLOCK = 'QUEUE_BLOCK'
export const SELECT_QUEUE_INDEX = 'SELECT_QUEUE_INDEX'
export const INCREASE_COLS = 'INCREASE_COLS'
export const DECREASE_COLS = 'PREV_QUEUE_ITEM'

// View
export const SET_ZOOM = 'SET_ZOOM'
export const SET_BOARD_SIZE = 'SET_BOARD_SIZE'

// Blocks
export const SELECT_BLOCKS = 'SELECT_BLOCKS'
export const BLOCK_HOVER_IN = 'BLOCK_HOVER_IN'
export const BLOCK_HOVER_OUT = 'BLOCK_HOVER_OUT'

// Edit
export const SET_TEXT_EDIT_MODE = 'SET_TEXT_EDIT_MODE' // Set to a specific block
export const SET_CROP_BLOCK = 'SET_CROP_BLOCK'
export const SET_PLACEMENT_MODE = 'SET_PLACEMENT_MODE' // text, color, null  // TODO: Add queue mode, replace SWITCH_TOGGLE:queue
export const SET_PLACEMENT_POSITION = 'SET_PLACEMENT_POSITION'
export const SET_DRAG_OFFSET = 'SET_DRAG_OFFSET'
export const TOGGLE_GRID_HIDE = 'TOGGLE_GRID_HIDE'

// Blocks
export const PLACE_BLOCK = 'PLACE_BLOCK'
export const COPY_BLOCKS = 'COPY_BLOCKS'
export const QUEUE_BLOCKS = 'QUEUE_BLOCKS'
export const CREATE_BLOCK = 'CREATE_BLOCK'
export const DELETE_BLOCKS = 'DELETE_BLOCKS'
export const SEND_TO_FRONT = 'SEND_TO_FRONT'
export const SEND_TO_BACK = 'SEND_TO_BACK'
export const GROUP = 'GROUP'
export const UNGROUP = 'UNGROUP'
// Text/Color Blocks
export const SET_BLOCK_PROPERTIES = 'SET_BLOCK_PROPERTIES'

// Upload
export const STORE_LOCAL_IMAGE = 'STORE_LOCAL_IMAGE'
export const GOT_LOCAL_IMAGE = 'GOT_LOCAL_IMAGE'
export const UPLOAD_COMPLETE = 'UPLOAD_COMPLETE'
export const DONE_WITH_LOCAL_IMAGE = 'DONE_WITH_LOCAL_IMAGE'

// History
export const HISTORY_ACTION = 'HISTORY_ACTION'
export const UNDO = 'UNDO'
export const REDO = 'REDO'

// Discuss
export const SELECT_THREAD = 'SELECT_THREAD'
export const TOGGLE_NEW_THREAD = 'TOGGLE_NEW_THREAD'
export const CANCEL_NEW_THREAD = 'CANCEL_NEW_THREAD'
export const PLACE_THREAD = 'PLACE_THREAD'
export const SHOW_RESOLVED_THREADS = 'SHOW_RESOLVED_THREADS'

// Activity
export const SHOW_ACTIVITY = 'SHOW_ACTIVITY'
export const SET_ACTIVITY_FILTER = 'SET_ACTIVITY_FILTER'
